import { Link } from "react-router-dom";
import { SITE } from "@/data/site";
import { externalLinkProps } from "@/lib/security";
import { FOOTER_LEGAL_LINKS } from "./footer-data";
import logo from "@/assets/logo-kc.png";

export const FooterBottom = () => (
  <>
    <div className="mt-20 flex flex-col items-start justify-between gap-6 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
      <div className="flex items-center gap-3">
        <img
          src={logo}
          alt="K&C Services"
          className="h-7 w-auto brightness-0 invert"
          width={110}
          height={28}
        />
        <span className="text-xs text-white/70">© 2019 {SITE.name}. Tous droits réservés.</span>
      </div>
      <ul className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-white/75">
        {FOOTER_LEGAL_LINKS.map((l) => (
          <li key={l.to}>
            <Link to={l.to} className="transition-colors hover:text-white">
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>

    <div className="mt-6 flex justify-end border-t border-white/5 pt-6">
      <p className="text-xs text-white/70">
        Designed & developed by{" "}
        <a
          href="https://barthez-kenwou.dev"
          {...externalLinkProps}
          className="font-medium text-white underline decoration-white/35 underline-offset-4 transition-colors hover:text-accent hover:decoration-accent"
        >
          Barthez Kenwou
        </a>
      </p>
    </div>
  </>
);
